import {
  GET_PROCESSOS_SUCCESS,
  GET_PROCESSOS_FAIL,
  UPDATE_PROCESSO_SUCCESS,
  UPDATE_PROCESSO_FAIL,
  POST_PROCESSO_SUCCESS,
  POST_PROCESSO_MSG,
  RESET_PROCCESS_MESSAGES
} from "./actionTypes"

const INIT_STATE = {
  processos: null,
  error: {},
  response: null,
}

const processo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROCESSOS_SUCCESS:
      return {
        ...state,
        processos: action.payload,
      }

    case GET_PROCESSOS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_PROCESSO_SUCCESS:
      return {
        ...state,
        processos: state.processos.map(processo =>
          processo.id.toString() === action.payload.id.toString()
            ? { processo, ...action.payload }
            : processo
        ),
      };

    case UPDATE_PROCESSO_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case POST_PROCESSO_SUCCESS:
      return {
        ...state,
        processos: action.payload,
      };

    case POST_PROCESSO_MSG:
      return {
        ...state,
        response: action.payload,
      };
    case RESET_PROCCESS_MESSAGES:
      return {
        ...state,
        response: null,
      };
    default:
      return state
  }
}

export default processo
